module.exports = __webpack_public_path__ + "img/legend-df.75434b4b.png";